import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden mb-16">
          <img
            src="https://readdy.ai/api/search-image?query=artistic%20product%20flatlay%20collage%20with%20sneakers%20streetwear%20bags%20and%20accessories%20on%20a%20light%20cream%20surface%2C%20soft%20film%20grain%20texture%2C%20warm%20neutral%20tones%2C%20minimalist%20editorial%20photography%2C%20gentle%20vignette%20effect%2C%20european%20catalog%20aesthetic%2C%20clean%20composition%20with%20natural%20lighting%20and%20soft%20shadows&width=1400&height=600&seq=cta-collage-kakobuy-01&orientation=landscape"
            alt="Kakobuy Spreadsheet product collection"
            className="w-full h-[340px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/30 via-transparent to-transparent"></div>
        </div>

        <div className="text-center">
          <p className="text-3xl md:text-4xl text-foreground-900 font-bold leading-snug mb-2 font-body">
            Nie trać czasu na
          </p>
          <p className="text-3xl md:text-4xl text-foreground-400 font-light italic leading-snug mb-2 font-heading">
            przeglądanie setek stron
          </p>
          <p className="text-3xl md:text-4xl text-foreground-900 font-extrabold leading-snug mb-12 font-body">
            Kup teraz przez Kakobuy Sheet.
          </p>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-10 py-4 bg-foreground-900 text-white text-[16px] font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-sm"
          >
            <i className="ri-external-link-line"></i>
            Odwiedź kaspreadsheet.com
          </a>
        </div>
      </div>
    </section>
  );
}